import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Popover } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyles = makeStyles((theme) => ({
  popover: {
    '& .MuiPaper-root': {
      margin: 'unset',
      padding: 'unset',
      boxShadow: 'unset',
      marginTop: '0.562rem',
    },
  },
  root: (props) => ({
    borderRadius: '0.625rem',
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.1)',
    background: '#fff',
    width: props.offsetWidth,
  }),
  selectDrop: {
    background: '#f5faff',
  },
}));

export default function DropSelectPop({ anchorEl, onClose, onChange, children, value }) {
  const classes = useStyles(anchorEl);
  const initSelectStatus = () => {
    const select = [];
    children.forEach((element) => {
      select.push(element.props.value === value);
    });
    return select;
  };
  const [isSelects, setIsSelects] = useState(initSelectStatus());

  return (
    <Popover
      className={classes.popover}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      disableScrollLock={true}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <div className={classes.root}>
        {children.map((item, index) => {
          const newItem = { ...item, props: { ...item.props } };
          const newClassName = isSelects[index] ? classes.selectDrop : '';
          newItem.props.className = classNames(newItem.props.className, newClassName);
          newItem.props.onClick = () => {
            setIsSelects(
              isSelects.map((_, position) => {
                return item === position;
              })
            );
            onChange(newItem.props.value);
            onClose();
          };
          return newItem;
        })}
      </div>
    </Popover>
  );
}
